import * as AuthConstants from '../constants/user-constants'

const initialState = {
  isTutorial: false,
  loading: false,
  signingOut: false,
  errorMessage: "",
  errorStatus: 0,
  errorType: null,
  appSignupError: false,
  appSignupSuccess: false,
  sendWelcomeEmailSuccess: false,
  loginError: false,
  loginSuccess: false,
  isAuthenticated: false,
  logOutError: false,
  logOutSuccess: false,
  verifyError: false,
  verifySuccess: false,
  passwordSuccess: false,
  passwordError: false,
  mailError: false,
  mailSuccess: false,
  putBadgeColor: true,
  putBadgeError: false,
  putBadgeSuccess: false,
  getBadgeColor: true,
  getBadgeError: false,
  getBadgeSuccess: false,
  getSettings: true,
  getSettingsError: false,
  getSettingsSuccess: false,
  user: {},
  userProfile: {},
  changePassData: {},
  mailData: {},
  colorData: {},
  credentialsData: {},
  defaultView: 'week',
  defaultDate: new Date(),
  seen: false,
  hasUpdate: false,
  hasChangesSettings: false,
  totalNotifications: 0,
  stepTutorial: 0,
  showMeTutorial: false,
  isFirstTutorial: true,
  followTuto: false
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthConstants.APP_SIGNUP_REQUEST:
      return {
        ...state,
        loading: true,
        appSignupError: false,
        appSignupSuccess: false,
      }
    case AuthConstants.APP_SIGNUP_SUCCESS:
      return {
        ...state,
        user: action.data.user,
        loading: false,
        appSignupSuccess: true,
        appSignupError: false,
        signingOut: false,
        showMeTutorial: true,
        isTutorial: true,
        isFirstTutorial: true
      }
    case AuthConstants.APP_SIGNUP_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.errorMessage,
        appSignupError: true,
        loading: false
      }
    case AuthConstants.LOGIN_REQUEST:
      return {
        ...state,
        token: "",
        errorMessage: "",
        loading: true,
        loginError: false,
        loginSuccess: false,
      };
    case AuthConstants.LOGIN_SUCCESS:
      return {
        ...state,
        user: action.data.user,
        loading: false,
        loginError: false,
        loginSuccess: true,
        signingOut: false,
        seen: false,
        defaultDate: new Date(),
        defaultView: 'week',
        stepTutorial: 0,
        isFirstTutorial: true,
        hasChangesSettings: false
      };
    case AuthConstants.LOGIN_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.errorMessage,
        loginError: true,
        loading: false
      };
    case AuthConstants.APP_GET_USER_REQUEST:
      return {
        ...state,
        loading: true
      }
    case AuthConstants.APP_GET_USER_SUCCESS:
        return {
          ...state,
          userProfile: action.data,
          loading: false,
          isAuthenticated: true
        }
    case AuthConstants.APP_GET_USER_FAILURE:
        return {
          ...state,
          loading: false,
          errorMessage: 'Unauthenticated'
        }                
    case AuthConstants.SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload
      }
    //Recover Password Actions
    case AuthConstants.RECOVER_PASS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        errorStatus: 0,
        loading: true,
        mailError: false,
        mailSuccess: false
      };
    case AuthConstants.RECOVER_PASS_SUCCESS:
      return {
        ...state,
        loading: false,
        mailData: action.data.data,
        mailSuccess: true
      };
    case AuthConstants.RECOVER_PASS_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.message,
        errorStatus: action.error.status,
        mailError: true,
        loading: false
      };

    //Change Password Actions
    case AuthConstants.CHANGE_PASS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        errorStatus: 0,
        loading: true,
        passwordSuccess: false,
      };
    case AuthConstants.CHANGE_PASS_SUCCESS:
      return {
        ...state,
        loading: false,
        changePassData: action.data.data,
        passwordSuccess: true
      };
    case AuthConstants.CHANGE_PASS_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.message,
        errorStatus: action.error.status,
        passwordError: true,
        loading: false
      };
      // 
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_REQUEST:
      return {
        ...state,
        errorMessage: "",
        errorStatus: 0,
        loading: true,
        verifyError: false,
        verifySuccess: false
      };
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        verifyData: action.data.data,
        verifySuccess: true
      };
    case AuthConstants.RECOVER_PASS_VERIFY_LINK_FAILURE:
      return {
        ...state,
        errorMessage: action.error.data.data,
        errorStatus: action.error.status,
        verifyError: true,
        loading: false
      };
    // crear user state
    case AuthConstants.CLEAR_USER_STATE:
      return {
        ...state,
        signingOut: false,
        loading: false,
        loginError: false,
        loginSuccess: false,
        errorStatus: 0,
        appSignupError: false,
        appSignupSuccess: false,
        errorMessage: null,
        errorType: null,
        isAuthenticated: false,
        defaultDate: new Date(),
        defaultView: 'week',
        stepTutorial: 0,
        isTutorial: false,
        hasChangesSettings: false,
        user: {}
      }
    // social login user
    case AuthConstants.SOCIAL_LOGIN_REQUEST:
      return {
        ...state,
        token: "",
        errorMessage: "",
        loading: true,
        socialLoginError: false,
        socialLoginSuccess: false,
      };
    case AuthConstants.SOCIAL_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.data.data,
        socialLoginSuccess: true,
        defaultDate: new Date(),
        defaultView: 'week',
        stepTutorial: 0,
        isTutorial: false,
        hasChangesSettings: false,
        seen: false
      };
    case AuthConstants.SOCIAL_LOGIN_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        loginError: true,
        loading: false
      };

    // log out
    case AuthConstants.LOGOUT_REQUEST:
      return {
        ...state,
        errorMessage: "",
        signingOut: true,
        logOutError: false,
        logOutSuccess: false,
      };
    case AuthConstants.LOGOUT_SUCCESS:
      return {
        ...state,
        signingOut: false,
        logOutSuccess: true,
        defaultDate: new Date(),
        defaultView: 'week',
        stepTutorial: 0,
        isTutorial: false,
        hasChangesSettings: false,
        seen: false,
        totalNotifications: 0
      };
    case AuthConstants.LOGOUT_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        loginError: true,
        signingOut: false
      };
    
    // put badge color
    case AuthConstants.PUT_BADGE_COLOR_REQUEST:
      return {
        ...state,
        errorMessage: "",
        putBadgeColor: true,
        putBadgeError: false,
        putBadgeSuccess: false,
      };
    case AuthConstants.PUT_BADGE_COLOR_SUCCESS:
      return {
        ...state,
        putBadgeColor: false,
        putBadgeSuccess: true,
      };
    case AuthConstants.PUT_BADGE_COLOR_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        putBadgeError: true,
        putBadgeColor: false
      };
    
    // get badge color
    case AuthConstants.GET_BADGE_COLOR_REQUEST:
      return {
        ...state,
        errorMessage: "",
        getBadgeColor: true,
        getBadgeError: false,
        getBadgeSuccess: false,
      };
    case AuthConstants.GET_BADGE_COLOR_SUCCESS:
      return {
        ...state,
        getBadgeColor: false,
        colorData: action.data.data,
        getBadgeSuccess: true,
      };
    case AuthConstants.GET_BADGE_COLOR_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        getBadgeError: true,
        getBadgeColor: false
      };
      //Change Password Actions
    case AuthConstants.CHANGE_LIVELI_PASS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        errorStatus: 0,
        loading: true,
        passwordSuccess: false,
      };
    case AuthConstants.CHANGE_LIVELI_PASS_SUCCESS:
      return {
        ...state,
        loading: false,
        changePassData: action.data.data,
        passwordSuccess: true
      };
    case AuthConstants.CHANGE_LIVELI_PASS_FAILURE:
      return {
        ...state,
        errorType: action.error.errorType,
        errorMessage: action.error.message,
        errorStatus: action.error.status,
        passwordError: true,
        loading: false
      };
    case AuthConstants.INITIAL_NOTIFICATIONS:
      return {
        ...state,
        hasUpdate: false,
        totalNotifications: action.data
      }
    // Set users values 
    case AuthConstants.SET_CALENDAR_DEFAULT_VIEW:
      return {
        ...state,
        defaultView: action.defaultView,
        defaultDate: action.date
      }
    case AuthConstants.SET_CALENDAR_SETTINGS:
      let user = state.userProfile;
      user = {
        ...user,
        weather: action.weather,
        timeZone: action.location
      }
      return {
        ...state,
        userProfile: user
      }
    case AuthConstants.SET_CALENDAR_CHANGES:
      return {
        ...state,
        hasChangesSettings: action.hasChangesSettings
      }
    case AuthConstants.SET_STEP_TUTORIAL:
      return {
        ...state,
        stepTutorial: action.step
      }
    case AuthConstants.SHOW_TUTORIAL:
      let isFirstTutorial = action.isFirstTutorial !== undefined ? action.isFirstTutorial : state.isFirstTutorial
      return {
        ...state,
        showMeTutorial: action.show,
        isTutorial: action.isTutorial,
        isFirstTutorial: isFirstTutorial
      }
    // get settings credentials
    case AuthConstants.GET_SETTINGS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        getSettings: true,
        getSettingsError: false,
        getSettingsSuccess: false,
      };
    case AuthConstants.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        getSettings: false,
        credentialsData: action.data.data.data,
        getSettingsSuccess: true,
      };
    case AuthConstants.GET_SETTINGS_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        getSettingsError: true,
        getSettings: false
      };
      // send welcome email
    case AuthConstants.SEND_WELCOME_EMAIL_BEGIN:
      return {
        ...state,
          sendWelcomeEmailSuccess: false,
          loading: true
      };
    case AuthConstants.SEND_WELCOME_EMAIL_SUCCESS:
      return {
        ...state,
        sendWelcomeEmailSuccess: true,
        loading: false
      };
    case AuthConstants.SEND_WELCOME_EMAIL_FAILURE:
      return {
        ...state,
        errorMessage: action.error.message,
        errorType: action.error.code,
        loading: true,
        sendWelcomeEmailSuccess: true
      };
    default:
      return state
  }
}
